<template>
  <b-col class="mt-2">
    <div class="accordion" role="tablist" style="width:100%">
      <div class="accordion-wrapper">
        <div v-b-toggle="`${id}-features`">
          <div class="row align-items-center no-gutters">
            <div class="col d-flex">
              <i :class="`fa-fw fa-check-circle check-icon mr-2 ${isCovered ? 'fas' : 'far'}`" />
              <div>
                <p class="mb-0">{{ tankName }}</p>
                <p class="receives-features-text">
                  {{ isCovered ? $t('xReceivesPremiumFeatures') : $t('xNotIncludedInPlan') }}
                </p>
              </div>
            </div>
            <div class="col-auto">
              <i class="fas fa-chevron-down when-closed"></i>
              <i class="fas fa-chevron-up when-open"></i>
            </div>
          </div>
        </div>
        <b-collapse :id="`${id}-features`">
          <div class="features">
            <div class="premium">
              <p class="mb-1">
                <strong>{{ $t('xFeaturesIncluded') }}</strong>
              </p>
              <div class="feature">
                <i class="fa-regular fa-gas-pump"></i>
                <div class="mb-2">
                  <p data-test-hook="tank-features-list-current-level-title">
                    <strong>{{ $t('xCurrentFuelLevel') }}</strong>
                  </p>
                  <p class="supporting-text" data-test-hook="tank-features-list-current-level-desc">
                    {{ $t('xFuelLevelDescription') }}
                  </p>
                </div>
              </div>
              <div class="feature">
                <i class="fa-regular fa-chart-line"></i>
                <div class="mb-2">
                  <p data-test-hook="tank-features-list-fuel-use-title">
                    <strong>{{ $t('xFuelUsageHistory') }}</strong>
                  </p>
                  <p class="supporting-text" data-test-hook="tank-features-list-fuel-use-desc">
                    {{ $t('xFuelUsageDescription') }}
                  </p>
                </div>
              </div>
              <div class="feature">
                <i class="fa-regular fa-warning"></i>
                <div class="mb-2">
                  <p data-test-hook="tank-features-list-warnings-title">
                    <strong>{{ $t('xFuelLevelWarnings') }}</strong>
                  </p>
                  <p class="supporting-text" data-test-hook="tank-features-list-warnings-desc">
                    {{ $t('xFuelLevelWarningsDescription') }}
                  </p>
                </div>
              </div>
              <div class="feature">
                <i class="fa-regular fa-battery-full"></i>
                <div class="mb-2">
                  <p data-test-hook="tank-features-list-battery-title">
                    <strong>{{ $t('xBatteryLevel') }}</strong>
                  </p>
                  <p class="supporting-text" data-test-hook="tank-features-list-battery-desc">
                    {{ $t('xBatteryLevelDescription') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </b-col>
</template>

<script>
export default {
  props: ['tankName', 'id', 'isCovered']
}
</script>
<style lang="scss">
.supporting-text {
  font-size: 0.875em;
  color: var(--gray-600);
  line-height: 1.25;
}
.check-icon {
  color: var(--blue-700);
}
.features {
  margin-top: 0.5em;
  gap: 0.75em;
  display: flex;
  flex-direction: column;
}
.feature {
  display: flex;
  align-items: center;
  gap: 0.5em;

  i {
    font-size: 1.125em;
    color: var(--carbon-600);
  }
  div {
    flex: 1;
  }
}
.collapsed .when-open,
.not-collapsed .when-closed {
  display: none;
}
</style>
